import { memo, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Card, Col, Container, Row, Spinner } from "react-bootstrap";

import { getNews, setFilter } from "../../redux/slices/NewsListSlice";

import HeaderBlue from "../Header/HeaderBlue";
import Paginator from "../Paginator";

import styles from "./NewsBlock.module.scss";

const NewsBlock = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { newsList, filter, language, loading } = useSelector(
    (state) => ({
      newsList: state.newsList?.newsList ?? {},
      filter: state.newsList?.filter,
      loading: state.newsList?.loading ?? false,
      language: state.LangSlice?.language ?? "ru",
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(getNews());
  }, [dispatch]);

  const results = newsList?.results ?? [];

  const cards = useMemo(
    () =>
      results.map((news) => (
        <Col key={news.id} className={styles.col}>
          <Card className={styles.card}>
            <Card.Body className={styles.cardBody}>
              <div className={styles.imageBlock}>
                <img
                  src={news.big_picture}
                  alt=""
                  height={250}
                  loading="lazy"
                />
              </div>
              <div className={styles.titleInfoBlock}>
                <div className={styles.titleBlock}>
                  {language === "en" ? (
                    <p>{news.title_en}</p>
                  ) : (
                    <p>{news.title}</p>
                  )}
                </div>
                <div className={styles.infoBlock}>
                  {language === "en" ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: news.full_description_en,
                      }}
                    />
                  ) : (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: news.full_description,
                      }}
                    />
                  )}
                </div>
                <div className={styles.linkBlock}>
                  <Link to={`/news-detail/${news.id}`}>
                    {t("newsBlock.link")}
                  </Link>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      )),
    [results, language, t]
  );

  return (
    <div className={styles.root}>
      <Container>
        <HeaderBlue />

        {loading ? (
          <div className={styles.loadingBlock}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <div className={styles.wrapper}>
              <div>
                <div
                  className={classNames(
                    "d-flex justify-content-between align-items-center",
                    styles.titleLinkBlock
                  )}
                >
                  <div>
                    <p>{t("newsBlock.title")}</p>
                  </div>
                </div>

                <Row xs={1} md={3} className={classNames("g-4", styles.row)}>
                  {cards}
                </Row>
              </div>
            </div>

            <Paginator
              filter={filter}
              response={newsList}
              setFilter={setFilter}
              getList={getNews}
            />
          </>
        )}
      </Container>
    </div>
  );
};

export default memo(NewsBlock);
